import React from "react";
import './Table.css'

const TableOne = ({
    pTableOneTitle,
    pTableOneN1, 
    pTableOneV1,
    pTableOneN2,
    pTableOneV2,
    pTableOneN3,
    pTableOneV3
 }) =>{
    return(
        <div id="tablebox"> <b className="heading">{pTableOneTitle}</b>
            <table class="table2">
                <tbody>
                    <tr>
                        <td class="td2"  width="100">{pTableOneN1}</td>
                        <td class="td2">{pTableOneV1}</td>
                    </tr>
                    <tr>
                        <td class="td2"  width="100">{pTableOneN2}</td>
                        <td class="td2">{pTableOneV2}</td>
                    </tr>
                    <tr>
                        <td class="td2"  width="100">{pTableOneN3}</td>
                        <td class="td2">{pTableOneV3}</td>
                    </tr>
                </tbody>
            </table>
        </div>
                
    );
}

export default TableOne;